enum RegistrationFieldTypes {
  ShortText = 'shortText',
  SingleChoice = 'singleChoice',
};

export default RegistrationFieldTypes;
